import React, { useEffect, useState } from "react";
import "./ProductList.scss";
import TableComponent from "../../../components/TableComponent/TableComponent";
import { Button, Switch, message } from "antd";
import {
  GET_PRODUCTS_LIST,
  PUBLISH_OR_UNPUBLISH_PRODUCT,
} from "../../../utils/apiPath";
import { postApi } from "../../../utils/apiServices";
import { useNavigate } from "react-router-dom";

const ProductList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const payload = {
        pageIndex: pagination.current - 1,
        pageSize: pagination.pageSize,
        searchString: "",
      };
      const { statusCode, data, message } = await postApi(
        GET_PRODUCTS_LIST,
        payload
      );

      if (statusCode === 200) {
        setData(data);
        setPagination((prev) => ({ ...prev, total: data?.totalRecords }));
      } else {
        console.error("Failed to fetch products:", message);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
    setLoading(false);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 100,
      // fixed: 'left',
    },
    {
      title: "Category",
      dataIndex: "categoryLayer1Title",
      key: "categoryLayer1Title",
    },
    {
      title: "MRP",
      dataIndex: "mrp",
      key: "mrp",
      render: (text) => `$${text.toFixed(2)}`,
    },
    {
      title: "Selling Price",
      dataIndex: "sellingPrice",
      key: "sellingPrice",
      render: (text) => `$${text.toFixed(2)}`,
    },
    {
      title: "Country of Origin",
      dataIndex: "countryOfOrigin",
      key: "countryOfOrigin",
    },
    {
      title: "Publish Status",
      dataIndex: "publishStatus",
      key: "publishStatus",
      render: (status, record) => (
        <Switch
          checked={status}
          checkedChildren="Published"
          unCheckedChildren="Unpublished"
          onChange={() => handleSwitchPublishing(record)}
        />
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Button onClick={() => handleEditClick(record?.id)}>🏀 Edit</Button>
          <Button onClick={() => handleReviews(record)}>👁️ Reviews</Button>
        </div>
      ),
    },
  ];

  const handleSwitchPublishing = async (record) => {
    const { statusCode } = await postApi(
      `${PUBLISH_OR_UNPUBLISH_PRODUCT}?productId=${record?.id}`,
      null
    );
    if (statusCode === 200) {
      fetchData();
      message.success(
        `Product ${
          record?.publishStatus ? "Unpublished" : "Published"
        } successfully`
      );
    }
  };

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  const handleAdd = () => {
    navigate("/manage/product/add");
  };

  const handleEditClick = (id) => {
    navigate(`/manage/product/edit/${id}`);
  };

  const handleReviews = (product) => {
    navigate("/manage/product-reviews", {
      state: { product: product },
    });
  };

  return (
    <div className="products">
      <div className="products_container">
        <div className="products_header">
          <div className="products_header_left">Products</div>
          <div className="products_header_right">
            <Button type="primary" onClick={handleAdd}>
              Add Product
            </Button>
          </div>
        </div>
        <TableComponent
          columns={columns}
          data={data}
          pagination={pagination}
          loading={loading}
          onTableChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default ProductList;
